<template>
    <section id="why-choose-us" class="py-5 bg-grey">
		<div class="container">
			<h2 class="text-center uc mb-5">Why Choose SaverCred?</h2>
			<div class="row justify-content-center mb-5">
				<div class="col-lg-8">
					<div class="box bg-white mb-3">
						<div class="d-flex align-items-center">
							<div>
								<h5>Fast Real Time Results</h5>
								Submit your request using SaverCred and we will search our network to find you a loan provider in real time, no expired offers, no waiting.
							</div>
							<div class="ml-auto pl-4 reason-icon">
								<object data="images/rocket.svg" type="image/svg+xml"></object>
							</div>
						</div>
					</div><!--End Box-->
					<div class="box bg-white mb-3">
						<div class="d-flex align-items-center">
							<div>
								<h5>Funds as Soon as the Next Business Day</h5>
								Our service connects you with lenders to conveniently get your Funds as quickly as possible.
							</div>
							<div class="ml-auto pl-4 reason-icon">
								<object data="images/credit.svg" type="image/svg+xml"></object>
							</div>
						</div>
					</div><!--End Box-->
					<div class="box bg-white mb-3">
						<div class="d-flex align-items-center">
							<div>
								<h5>All Credit Types Accepted</h5>
								Our lender network allows your request to be seen by multiple lenders, which should increase your odds of acceptance.
							</div>
							<div class="ml-auto pl-4 reason-icon">
								<object data="images/check.svg" type="image/svg+xml"></object>
							</div>
						</div>
					</div><!--End Box-->
					<div class="box bg-white">
						<div class="d-flex align-items-center">
							<div>
								<h5>Safe and Secure</h5>
								Your personal data is secured using industry 256-bit SSL encryption technology when using our service.
							</div>
							<div class="ml-auto pl-4 reason-icon">
								<object data="images/lock.svg" type="image/svg+xml"></object>
							</div>
						</div>
					</div><!--End Box-->
				</div><!--End Col 8-->
			</div><!--End Row-->
			<div class="call-to-action text-center">
				<HomeLeadFormButton v-if="mode != 'hash'" />
                <div v-else>
                    <a href="#step-1" class="btn btn-cta uc" v-scroll-to="'#step-1'">Get Started</a>
                </div>
			</div>
		</div><!--End Container-->
	</section>
</template>

<script>
import HomeLeadFormButton from '@/components/home/HomeLeadFormButton.vue';

export default {
    name: 'WhyChoose',
    components: {
        HomeLeadFormButton
    },
    props: {
        mode: {
            type: String,
            default: "history"
        }
    }
}
</script>

<style>

</style>
